import { useLayoutEffect, useState } from "react";
import { CategoryVP } from "../editor/AlternativesEditor";
import SvgWrappableText from "./SvgWrappableText";

interface SvgCategoryBubblesProps {
  category: CategoryVP;
  textColor: string;
  top: number;
  margin: number;
  fontSize: number;
  onLayout: (height: number) => void;
}

export default function SvgCategoryBubbles(props: SvgCategoryBubblesProps) {
  const { category, top, margin, textColor, fontSize, onLayout } = props;
  const [height, setHeight] = useState(180);
  const [height2, setHeight2] = useState(180);

  const w = 5 * 702;
  const textSideMargin = 80 * fontSize / 100;
  const textTopMargin = 40 * fontSize / 100;
  const strokeWidth = 10 * fontSize / 100;
  const cornerRadius = fontSize;
  const bubbleWidth = 1450;

  useLayoutEffect(() => {
    // Doing this here because we can't forward onLayout 
    // up the chain until we've received both callback from the children
    onLayout(Math.max(height, height2));
  }, [height, height2]);

  const handleLeftBubbleLayout = (h) => {
    const newHeight = h + 2 * textTopMargin;
    setHeight(newHeight);
  }

  const handleRightBubbleLayout = (h) => {
    const newHeight = h + 2 * textTopMargin;
    setHeight2(newHeight);
  }

  const y1 = top + (height2 > height ? 0.5 * (height2 - height) : 0);
  const y2 = top + (height2 < height ? 0.5 * (height - height2) : 0);
  const x1 = margin
  const x2 = w - margin - bubbleWidth;

  const ay = y1 + 0.5 * height;
  const ax1 = x1 + bubbleWidth + 60;
  const ax2 = x2 - 60;

  return (
    <g>
      <path 
        fill={textColor}
        stroke='#FFFFFF'
        strokeWidth={3}
        d={`M${ax1} ${ay - 8} l${ax2 - ax1 - 33} 0 l0 -25 l33 33 l-33 33 l0 -25 l${ax1 - ax2 + 33} 0 Z`} />
      <rect 
        x={margin}
        y={y1}
        width={bubbleWidth}
        height={height}
        rx={cornerRadius}
        ry={cornerRadius}
        fill={`rgba(255, 255, 255, 0.88)`}
      />
      <rect 
        x={margin}
        y={y1}
        width={bubbleWidth}
        height={height}
        rx={cornerRadius}
        ry={cornerRadius}
        fill="none"
        stroke="grey"
        strokeWidth={strokeWidth}
      />
      <SvgWrappableText
        text={category.avoid.map((p) => p.name).join(", ")}
        color={textColor}
        x={margin + textSideMargin}
        top={y1 + textTopMargin}
        fontSize={fontSize}
        fontWeight="600"
        width={bubbleWidth - 2 * textSideMargin}
        textAnchor="start"
        onLayout={(h) => handleLeftBubbleLayout(h)}
      />
      <rect 
        x={x2}
        y={y2}
        width={bubbleWidth}
        height={height2}
        rx={cornerRadius}
        ry={cornerRadius}
        fill={`rgba(255, 255, 255, 0.88)`}
      />
      <rect 
        x={x2}
        y={y2}
        width={bubbleWidth}
        height={height2}
        rx={cornerRadius}
        ry={cornerRadius}
        fill="none"
        stroke={textColor}
        strokeWidth={strokeWidth}
      />
      <SvgWrappableText 
        text={category.consider.map((p) => p.name).join(", ")}
        color={textColor}
        x={x2 + textSideMargin}
        top={y2 + textTopMargin}
        fontSize={fontSize}
        fontWeight="600"
        width={bubbleWidth - 2 * textSideMargin}
        textAnchor="start"
        onLayout={(h) => handleRightBubbleLayout(h)}
      />
    </g>
  )
}